import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Slide,
  Typography,
} from '@mui/material';
import {Form} from 'formik';
import {getFormField} from 'pages/uiwisePages/UiWiseWidget/FormWidget/FormFields';
import WidgetAction from 'pages/uiwisePages/UiWiseWidget/WidgetAction';
import PropTypes, {object} from 'prop-types';
import React, {useEffect} from 'react';
import {UiWiseFormFieldType} from 'shared/constants/UiWiseConst';
import AppGridContainer from '../AppGridContainer';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const ConfirmDialog = ({widgetid, alertSpec, isOpen, onConfirm, onClose}) => {
  const {title, message, fields = [], actions = []} = alertSpec || {};

  const handleActionClick = (actiontype) => {
    if (actiontype === 'submit') {
      onConfirm();
    } else {
      onClose(false);
    }
  };

  useEffect(() => {
    const root = document.getElementById('root');
    if (!root) return;

    if (isOpen) {
      root.setAttribute('inert', '');
    } else {
      root.removeAttribute('inert');
    }
    return () => root.removeAttribute('inert');
  }, [isOpen]);

  return (
    <Dialog
      id={widgetid}
      TransitionComponent={Transition}
      open={isOpen}
      onClose={() => onClose(false)}
      fullWidth
      maxWidth='xs'
      aria-labelledby={widgetid}
    >
      {title && (
        <DialogTitle id={widgetid}>
          <Typography>{title}</Typography>
        </DialogTitle>
      )}

      <DialogContent>
        {message && (
          <Typography variant='body2' sx={{mt: 2}}>
            {message}
          </Typography>
        )}

        {fields && (
          <Form>
            {fields
              .filter((field) => field.fieldtype === UiWiseFormFieldType.HIDDEN)
              .map((field, i) => (
                <React.Fragment key={`${field.name}-${i}`}>
                  {getFormField(widgetid, field)}
                </React.Fragment>
              ))}
            <AppGridContainer
              spacing={4}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                my: 2,
              }}
            >
              {fields
                .filter(
                  (field) => field.fieldtype !== UiWiseFormFieldType.HIDDEN,
                )
                .map((field, i) => (
                  <Grid item key={i}>
                    {getFormField(widgetid, field)}
                  </Grid>
                ))}
            </AppGridContainer>
          </Form>
        )}
      </DialogContent>

      {actions.length > 0 && (
        <DialogActions>
          {actions?.map((action, i) => {
            const itemKey = `${widgetid}-${i}`;
            return (
              <Grid item key={itemKey}>
                <WidgetAction
                  action={action}
                  onClick={() => handleActionClick(action.actiontype)}
                  sx={{minWidth: 64}}
                />
              </Grid>
            );
          })}
        </DialogActions>
      )}
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  widgetid: PropTypes.string.isRequired,
  alertSpec: PropTypes.shape({
    title: PropTypes.string.isRequired,
    message: PropTypes.string,
    fields: PropTypes.arrayOf(object),
    actions: PropTypes.arrayOf(WidgetAction.propTypes.action).isRequired,
  }).isRequired,

  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ConfirmDialog;
